import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

// Control center › SQL datasets: the list, a new dataset and one dataset.
export const createSqlDatasetsRouteMap = (prefix: string) => ({
  new: pathJoin(prefix)('new').chainWithTitle({
    title: <T _str="New SQL dataset" />,
    breadCrumbTitle: <T _str="New SQL dataset" />,
  }),
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainWithTitle({
      title: <T _str="SQL dataset" />,
      breadCrumbTitle: <T _str="SQL dataset" />,
    }),
})
